<template>
  <div class="mb-16">
    <h1 class="heading-1">
      {{ product.titles.raw }}
    </h1>

    <RatingInfo v-if="rating && !hideRating" anchor-id="reviews" :rating />

    <PopularityStatsSalesCaption
      v-if="popularityStatsSales && popularityStatsSales[0]"
      :popularity-stats-sales="popularityStatsSales[0]"
    />

    <div class="mt-24 flex items-center gap-12">
      <Price
        v-if="product && selectedOffer"
        class="grow"
        :mobile-plan="selectedMobilePlan"
        :price
        :product
        :selected-offer
      />

      <RevButton
        class="mood-tangaroa min-w-[164px] max-w-[256px] grow"
        data-id="product-page-buy-button-desktop"
        data-qa="product-page-buy-button-desktop"
        variant="primary"
        @click="onAddToCart"
      >
        {{ i18n(translations.addToCart) }}
      </RevButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
// fixme: duplicated code due to Japan improved PP
import type { Price as PriceType } from '@backmarket/http-api'
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'
import type { PopularityStatsSales } from '@backmarket/http-api/src/api-specs-checkout/popularity-stats/popularity-stats.types'
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import type { Rating } from '@backmarket/http-api/src/api-specs-reviews/types/rating'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import translations from '~/scopes/product/components/Title/TitleDesktop.translations'
import { useAddToCart } from '~/scopes/product-core/components/containers/ContainerAddToCart/composables/useAddToCart/useAddToCart'
import { useProductTracking } from '~/scopes/product-core/composables/useProductTracking/useProductTracking'
import Price from '~/scopes/product-core/pages/ProductDetailPage/jp/components/JPContainerPrice/components/Price/Price.vue'
import PopularityStatsSalesCaption from '~/scopes/product-core/pages/ProductDetailPage/jp/components/presentationals/PopularityStatsSalesCaption/PopularityStatsSalesCaption.vue'
import RatingInfo from '~/scopes/reviews/reviews-display/components/Rating/Rating.vue'

const props = withDefaults(
  defineProps<{
    selectedOffer?: GetPickersResponse['selectedOffer']
    product: GetProductResponse
    price: PriceType
    rating?: Rating | null
    tracking: ReturnType<typeof useProductTracking>
    selectedMobilePlan?: MobilePlanOffer
    hideRating?: boolean
    popularityStatsSales?: PopularityStatsSales[] | null
  }>(),
  {
    selectedOffer: null,
    selectedMobilePlan: undefined,
    rating: null,
    hideRating: false,
    popularityStatsSales: null,
  },
)

const { addToCart } = useAddToCart()
const i18n = useI18n()

function onAddToCart() {
  if (props.selectedOffer && props.selectedOffer.offerLegacyId) {
    addToCart({
      listingId: props.selectedOffer.offerLegacyId,
      listingPublicId: props.selectedOffer.offerId,
      tracking: {
        ...props.tracking.product.value,
        list: 'product_page',
        campaign_id: props.selectedOffer.campaignId,
        population_id: props.selectedOffer.populationId,
      },
      partnerPromoCodes: props.product.includedServiceOffers.partnerPromoCodes,
      isTradeInEligible: props.product.isTradeInEligible,
    })
  }
}
</script>
